import * as React from 'react'

import Grid       from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { FieldArray }       from 'formik'
import { FormattedMessage } from 'react-intl'

import { FormikFormChunkProps } from '../../../types'
import { ActionButton }         from '../../atoms'
import {
  ExperienceCard,
  InteractiveCard,
}                               from '../../molecules'
import { i18nErrorCodes }       from '../form-utils'
import SingleExperienceForm     from '../SingleExperienceForm'
import { ExperienceFields }     from '../types'

const ExperiencesChunk: React.SFC<FormikFormChunkProps<ExperienceFields>> = ({
  errors,
  values: { experiences },
}) => (
  <Grid container spacing={24}>
    <Grid item xs={12}>
      <Typography variant={'subheading'}>
        <FormattedMessage
          id={'forms.fillInExperiencePrompt'}
          defaultMessage={'Add your previous professional experience'}
        />
      </Typography>
    </Grid>
    <FieldArray
      name={'experiences'}
      render={({ push, remove }) => (
        <>
          <Grid
            justify={'space-between'}
            alignItems={'center'}
            container
            xs={12}
            item
          >
            <Typography variant={'subheading'}>
              <FormattedMessage
                defaultMessage={'Professional experiences'}
                id={'forms.experiences'}
              />
            </Typography>
            <SingleExperienceForm
              save={push}
            >
              {({ open }) => (
                <ActionButton
                  actionType={'add'}
                  onClick={open}
                  color={'primary'}
                />
              )}
            </SingleExperienceForm>
          </Grid>
          {experiences.map((experience, i) => (
            <Grid
              item
              xs={12}
              key={
                experience.position
                + experience.company
              }
            >
              <InteractiveCard onRemove={() => remove(i)}>
                <ExperienceCard {...experience} />
              </InteractiveCard>
            </Grid>
          ))}
        </>
      )}
    />
    {errors.experiences && (
      <Grid item xs={12}>
        <Typography variant={'subheading'} color={'error'}>
          <FormattedMessage id={'validation.' + i18nErrorCodes.minOneExperienceRequired} />
        </Typography>
      </Grid>
    )}
  </Grid>
)

export default ExperiencesChunk



// WEBPACK FOOTER //
// ./src/components/forms/chunks/ExperiencesChunk.tsx